import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/passwordForgotten`;

export const ROUTE: RouteDefinition = `${baseRoute}/passwordForgotten`;

export const URL = (): RouteDefinition => `${baseRoute}/passwordForgotten`;
